"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCore = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const components_1 = require("Views/Shared/Components/LearningComponent/components");
const expandWrapper_1 = require("../ExpandWrapper/expandWrapper");
const MobileFilter_1 = require("../Filters/MobileFilter");
const KeepTheRhythm_1 = require("../KeepTheRhythm");
const components_2 = require("../Table/components");
const components_3 = require("./components");
const dictionary_1 = require("./dictionary");
const helpers_1 = require("./helpers");
const Sidebar_1 = require("../Sidebar");
const typings_1 = require("./typings");
class TableCore extends React.Component {
    constructor(props) {
        super(props);
        this.onWindowResize = (0, app_1.throttle)(this.detectBreakpointOnResize.bind(this), 100);
        this.tableWrapperRef = React.createRef();
        this.tableAriaLiveRef = React.createRef();
        this.maxVisibleRowCount = 9;
        this.getInitialFilters = () => {
            const { columns, filterItems } = this.props;
            const filterableColumns = columns.filter(column => column.filterable || column.searchable);
            const filterGroupsOrder = filterableColumns.map(column => column.name);
            const filters = filterableColumns.reduce((acc, column) => {
                const { name, label, searchable } = column;
                const items = filterItems && filterItems[name]
                    ? filterItems[name].map((item) => ({
                        title: item,
                        value: item,
                        selected: false,
                        documentsCount: 0,
                    }))
                    : [];
                const filterGroup = {
                    title: label,
                    value: name,
                    items,
                    isCollapsed: false,
                    type: searchable ? typings_1.TableFilterType.Searchable : typings_1.TableFilterType.Filterable,
                    guiType: 0,
                };
                return Object.assign(Object.assign({}, acc), { [name]: filterGroup });
            }, {});
            if (filters.languages && filters.languages.items.length > 1) {
                (0, app_1.sortByKey)(filters.languages.items, 'title');
            }
            return { filterGroupsOrder, filters };
        };
        this.onExpandButtonClick = isOpened => {
            this.setState({
                isTableExpanded: isOpened,
            }, () => {
                if (isOpened) {
                    this.focusFirstInvisibleRow();
                }
                else {
                    this.updateExpandWrapper();
                }
            });
        };
        this.focusFirstInvisibleRow = () => {
            const isLearningTable = this.props.tableType === typings_1.TableTypeEnum.Learning;
            const selector = isLearningTable
                ? 'tbody tr:not(.learning-table-body-description-row)'
                : 'tbody:not(.table-row-group)';
            const firstInvisibleRow = $(this.tableWrapperRef.current).find(selector)[this.maxVisibleRowCount];
            if (!firstInvisibleRow)
                return;
            // Setting 300ms timeout to let screen reader read aloud expanded state change.
            setTimeout(() => {
                firstInvisibleRow.focus();
            }, 300);
        };
        this.showMobileFilter = () => {
            this.setState({ visibleMobileFilter: true });
        };
        this.closeMobileFilter = () => {
            this.setState({ visibleMobileFilter: false });
        };
        this.onFilterReset = () => {
            const { selectedFilters, filters } = this.state;
            this.setState({
                selectedFilters: Object.keys(selectedFilters).reduce((p, n) => {
                    if (filters[n].type === typings_1.TableFilterType.Filterable) {
                        return Object.assign(Object.assign({}, p), { [n]: [] });
                    }
                    if (filters[n].type === typings_1.TableFilterType.Searchable) {
                        return Object.assign(Object.assign({}, p), { [n]: [''] });
                    }
                }, {}),
                selectedFiltersCount: 0,
            }, this.filterTable);
        };
        this.rowItemHasAppliedFilter = (sF, rowItem, group) => {
            let index;
            if (Array.isArray(rowItem)) {
                rowItem = rowItem;
                index = (0, app_1.findIndex)(sF, filterValue => rowItem.indexOf(filterValue) !== -1);
            }
            else if (group === 'status') {
                index = (0, app_1.findIndex)(sF, filterValue => rowItem.title.indexOf(filterValue) !== -1);
            }
            else {
                index = sF.indexOf(rowItem);
            }
            return index !== -1;
        };
        this.filterTable = () => {
            const { rows } = this.props;
            const { filters, selectedFilters, lastUpdatedFiltersGroup } = this.state;
            const selectedFilterGroups = Object.keys(selectedFilters);
            const nextRows = rows.filter(row => {
                return selectedFilterGroups
                    .map(group => {
                    const filterType = filters[group].type;
                    switch (filterType) {
                        case typings_1.TableFilterType.Filterable: {
                            const sF = group !== lastUpdatedFiltersGroup
                                ? selectedFilters[group]
                                : selectedFilters[group].filter(filterValue => {
                                    const i = (0, app_1.findIndex)(filters[group].items, item => {
                                        return item.value === filterValue;
                                    });
                                    return filters[group].items[i].documentsCount !== 0;
                                });
                            return sF.length === 0 || this.rowItemHasAppliedFilter(sF, row[group], group);
                            break;
                        }
                        case typings_1.TableFilterType.Searchable: {
                            const filterValue = selectedFilters[group][0].toLowerCase().trim();
                            const rowValue = row[group].toLowerCase();
                            return rowValue.includes(filterValue);
                            break;
                        }
                    }
                })
                    .every(item => item);
            });
            this.setState({
                rows: nextRows,
                isNothingFound: nextRows.length ? false : true,
            }, () => {
                if (this.expandableWrapper) {
                    const additionalExpandedRowsHeight = this.calcHeightOfExpandedRows();
                    this.expandableWrapper.updateExpand(additionalExpandedRowsHeight);
                }
            });
        };
        this.updateExpandWrapper = () => {
            if (!this.expandableWrapper || this.state.isTableExpanded)
                return;
            const additionalExpandedRowsHeight = this.calcHeightOfExpandedRows(true);
            this.expandableWrapper.updateExpand(additionalExpandedRowsHeight);
        };
        this.handleColumnHeaderClick = (e) => {
            const sortColumn = e.currentTarget.getAttribute('data-filter-group') || '';
            if (sortColumn === this.state.sortColumn) {
                this.setState({
                    sortOrder: this.state.sortOrder === typings_1.OrderTypeEnum.Ascending
                        ? typings_1.OrderTypeEnum.Descending
                        : typings_1.OrderTypeEnum.Ascending,
                }, this.updateExpandWrapper);
            }
            else {
                this.setState({
                    sortColumn,
                    sortOrder: sortColumn === dictionary_1.tableDictionary.updated
                        ? typings_1.OrderTypeEnum.Descending
                        : typings_1.OrderTypeEnum.Ascending,
                }, this.updateExpandWrapper);
            }
        };
        this.selectedGroupRow = (row, nextGroup) => {
            const { selectedFilters, filters } = this.state;
            const selectedFilterGroups = Object.keys(selectedFilters);
            return selectedFilterGroups.every(group => {
                var _a;
                if (group === nextGroup)
                    return true;
                const rowData = row[group];
                const filterType = (_a = filters[group]) === null || _a === void 0 ? void 0 : _a.type;
                switch (filterType) {
                    case typings_1.TableFilterType.Filterable: {
                        const selectedFilterOption = selectedFilters[group];
                        if (!selectedFilterOption || selectedFilterOption.length === 0)
                            return true;
                        if (Array.isArray(rowData)) {
                            return rowData.some(value => selectedFilterOption.indexOf(value) !== -1);
                        }
                        else if (group === 'status') {
                            return selectedFilterOption.indexOf(rowData.title) !== -1;
                        }
                        else {
                            return selectedFilterOption.indexOf(rowData) !== -1;
                        }
                    }
                    case typings_1.TableFilterType.Searchable: {
                        const filterValue = selectedFilters[group][0].toLowerCase().trim();
                        const rowValue = rowData.toLowerCase();
                        return rowValue.includes(filterValue);
                    }
                    default: {
                        return true;
                    }
                }
            });
        };
        this.onFilterGroupChange = (nextGroup) => {
            if (!nextGroup)
                return;
            const { filters } = this.state;
            const { rows } = this.props;
            const probableNextRows = rows.filter(row => this.selectedGroupRow(row, nextGroup));
            const nextFilters = Object.assign({}, filters);
            nextFilters[nextGroup].items.forEach(filterItem => {
                const index = (0, app_1.findIndex)(probableNextRows, row => {
                    const rowData = row[nextGroup];
                    if (Array.isArray(rowData)) {
                        return rowData.includes(filterItem.value);
                    }
                    else if (nextGroup === 'status') {
                        return rowData.title === filterItem.value;
                    }
                    else {
                        return rowData === filterItem.value;
                    }
                });
                filterItem.documentsCount = index === -1 ? 0 : 1;
            });
            this.setState({ filters: nextFilters });
        };
        this.onFilterChange = (group, filterValue, resetFilter = false) => {
            const { selectedFilters } = this.state;
            let updatedFilters;
            if (resetFilter) {
                updatedFilters = [];
            }
            else {
                const groupFilters = selectedFilters[group];
                const filterIndex = groupFilters.indexOf(filterValue);
                if (filterIndex === -1) {
                    updatedFilters = [...groupFilters, filterValue];
                }
                else {
                    updatedFilters = groupFilters.filter(item => item !== filterValue);
                }
            }
            const nextSelectedFilters = Object.assign(Object.assign({}, selectedFilters), { [group]: updatedFilters });
            const selectedFiltersCount = (0, helpers_1.getSelectedFiltersCount)(nextSelectedFilters);
            this.setState({
                lastUpdatedFiltersGroup: group,
                selectedFilters: nextSelectedFilters,
                selectedFiltersCount,
            }, this.filterTable);
        };
        this.onSearchFilterChange = (group, filterValue) => {
            const { selectedFilters } = this.state;
            this.setState({
                selectedFilters: Object.assign(Object.assign({}, selectedFilters), { [group]: [filterValue] }),
            }, this.filterTable);
        };
        this.onFilterCancel = (previousSelectedFilters) => {
            this.setState({
                selectedFilters: previousSelectedFilters,
                selectedFiltersCount: (0, helpers_1.getSelectedFiltersCount)(previousSelectedFilters),
            }, this.filterTable);
        };
        this.calcHeightOfExpandedRows = (checkOnlyVisible = false) => {
            const tableMainRows = $(this.tableWrapperRef.current).find('.row-with-expand-button');
            const isLearningTable = this.props.tableType === typings_1.TableTypeEnum.Learning;
            let expandedRowsHeight = 0;
            const isExpanded = ($el) => $el.hasClass('expanded');
            const isVisible = ($el) => $el.attr('aria-hidden') !== 'true';
            for (let i = 0; i < this.maxVisibleRowCount; i++) {
                if (!tableMainRows[i]) {
                    break;
                }
                const $rowWithExpandBtn = $(tableMainRows[i]);
                if (checkOnlyVisible && !isVisible($rowWithExpandBtn.parent())) {
                    break;
                }
                if (isLearningTable && isExpanded($rowWithExpandBtn)) {
                    expandedRowsHeight += $rowWithExpandBtn.next().height();
                }
                else if (!isLearningTable && isExpanded($rowWithExpandBtn.parent())) {
                    expandedRowsHeight += $rowWithExpandBtn.parent().next().height();
                }
            }
            return expandedRowsHeight;
        };
        const { filterGroupsOrder, filters } = this.getInitialFilters();
        this.state = {
            isDesktop: (0, app_1.isDesktop)(),
            isMobile: (0, app_1.isMobile)(),
            visibleMobileFilter: false,
            rows: props.rows,
            selectedFilters: (0, helpers_1.getSelectedFiltersFromFilters)(filters),
            selectedFiltersCount: 0,
            sortColumn: dictionary_1.tableDictionary.name,
            sortOrder: typings_1.OrderTypeEnum.Ascending,
            lastUpdatedFiltersGroup: '',
            filters: filters,
            filterGroupsOrder: filterGroupsOrder,
            isTableExpanded: props.tileStatusExpanded,
            isNothingFound: false,
        };
        this.resetFilterHTML = document.createElement('div');
    }
    componentDidMount() {
        this.tableUniqueId = app_1.UtilService.generateUniqueID(5);
        this.initExpandWrapper();
        if (this.props.tableType === typings_1.TableTypeEnum.Learning) {
            $(this.tableWrapperRef.current)
                .closest('.learning-component')
                .find('.tabs-title')
                .prepend(this.resetFilterHTML);
        }
        else {
            $(this.tableWrapperRef.current)
                .closest('.container-fluid')
                .prev('.container-fluid')
                .find('.tabs-title')
                .prepend(this.resetFilterHTML);
        }
        window.addEventListener('resize', this.onWindowResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    render() {
        const { dictionary, className, tableType, columns, status, tableWrapperClassName, tableCaption, } = this.props;
        const { isDesktop, visibleMobileFilter, filters, selectedFiltersCount, selectedFilters, filterGroupsOrder, sortOrder, sortColumn, rows, isTableExpanded, isNothingFound, } = this.state;
        const subDictionaries = (0, helpers_1.createTableSubDictionaries)(dictionary);
        const tableWithValidForClass = columns.some(item => item.name === 'validFor')
            ? 'table-with-valid-for'
            : '';
        const isNoData = !rows.length && !isNothingFound;
        return ((0, jsx_runtime_1.jsxs)("div", { className: `${tableWrapperClassName}`, ref: this.tableWrapperRef, children: [!isNoData && ((0, jsx_runtime_1.jsx)(components_3.MobileControlPanel, { dictionary: subDictionaries.mobileControlPanelDictionary, selectedFiltersCount: selectedFiltersCount, filters: filters, showMobileFilter: this.showMobileFilter, onSearchFilterChange: this.onSearchFilterChange })), !!selectedFiltersCount && ((0, jsx_runtime_1.jsx)(components_3.ResetFiltersButton, { buttonWrapper: this.resetFilterHTML, buttonLabel: dictionary.resetAllFiltersLabel, onFilterReset: this.onFilterReset })), (0, jsx_runtime_1.jsx)("div", { className: "screen-reader-only hidden", ref: this.tableAriaLiveRef, "aria-live": "assertive", "aria-atomic": "true", role: "alert" }), (0, jsx_runtime_1.jsxs)("table", { className: `transition-all ${className} ${tableWithValidForClass}`, role: "grid", id: `${tableType}-expand-content-${this.tableUniqueId}`, children: [(0, jsx_runtime_1.jsx)("caption", { className: "screen-reader-only hidden", children: tableCaption }), (0, jsx_runtime_1.jsx)(components_3.TableHead, { columns: columns, filters: filters, selectedFilters: selectedFilters, sortOrder: sortOrder, sortColumn: sortColumn, isDesktop: isDesktop, tableWrapperRef: this.tableWrapperRef, tableAriaLiveRef: this.tableAriaLiveRef, resetFilterLabel: dictionary.resetFilterLabel, handleColumnHeaderClick: this.handleColumnHeaderClick, onFilterGroupChange: this.onFilterGroupChange, onFilterChange: this.onFilterChange, onSearchFilterChange: this.onSearchFilterChange, isNoData: isNoData, sortingAriaLabels: subDictionaries.accessibilitySortingDictionary, searchInputAriaLabel: dictionary.search }), tableType === typings_1.TableTypeEnum.Learning ? ((0, jsx_runtime_1.jsx)(components_1.LearningTableBody, { coursesData: rows, columns: columns, tableWrapperRef: this.tableWrapperRef, expandableWrapper: this.expandableWrapper, maxVisibleRowCount: this.maxVisibleRowCount, dictionary: dictionary, isMobile: this.state.isMobile, sortColumn: sortColumn, sortOrder: sortOrder, isTableExpanded: isTableExpanded, tableUniqueId: this.tableUniqueId })) : ((0, jsx_runtime_1.jsx)(components_2.TableBody, { rows: rows, columns: columns, tableType: tableType, tableWrapperRef: this.tableWrapperRef, expandableWrapper: this.expandableWrapper, dictionary: subDictionaries.tableBodyDictionary, isDesktop: this.state.isDesktop, maxVisibleRowCount: this.maxVisibleRowCount, sortColumn: sortColumn, sortOrder: sortOrder, isTableExpanded: isTableExpanded }))] }), !rows.length && ((0, jsx_runtime_1.jsx)(components_3.NoDataMessage, { tableStatus: status, isNothingFound: isNothingFound, zeroResultMessage: dictionary.zeroResultMessage, noDataLabel: dictionary.noDataLabel })), (0, jsx_runtime_1.jsx)(Sidebar_1.default, { opened: visibleMobileFilter, className: "filters-sidebar max-w-[calc(100%-30px)]", closeBreakpoint: app_1.Breakpoint.SM, close: this.closeMobileFilter, children: (0, jsx_runtime_1.jsx)(MobileFilter_1.default, { filters: filters, filterGroupsOrder: filterGroupsOrder, selectedFilters: selectedFilters, selectedFiltersCount: selectedFiltersCount, onFilterChange: this.onFilterChange, onFilterGroupChange: this.onFilterGroupChange, onFilterReset: this.onFilterReset, onCancel: this.onFilterCancel, hideGroupsWithOneItem: true, close: this.closeMobileFilter, dictionary: subDictionaries.mobileFilterDictionary }) })] }));
    }
    initExpandWrapper() {
        if (!this.state.rows || !this.state.rows.length) {
            return null;
        }
        this.expandableWrapper = new expandWrapper_1.ExpandableWrapper({
            ctaClass: 'cta--small cta--block',
            data: this.props.dictionary, // use same names for each table
            minHeight: () => {
                let countHeight = 0;
                countHeight += $(this.tableWrapperRef.current).find('thead').height() || 0;
                const inTable = $(this.tableWrapperRef.current).find('.table-specific-row, .table-row-group:not(.collapsed), .table-basic-row, .learning-table-body-main-row');
                for (let i = 0; i < this.maxVisibleRowCount; i++) {
                    if (!inTable[i]) {
                        break;
                    }
                    countHeight += $(inTable[i]).height();
                }
                countHeight += KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2;
                if (this.state.isNothingFound) {
                    countHeight += 48; // Plus Not found message elements height
                }
                return countHeight;
            },
        });
        this.expandableWrapper.initExpandableWrapper({
            element: this.tableWrapperRef.current,
            wrapper: this.tableWrapperRef.current.closest(this.props.expandableWrapperClassName),
            onClickHandler: this.onExpandButtonClick,
            tableType: this.props.tableType,
            tableUniqueId: this.tableUniqueId,
        });
        this.forceUpdate();
    }
    detectBreakpointOnResize() {
        this.setState({
            isDesktop: (0, app_1.detectBreakpoint)(app_1.Breakpoint.LG),
            isMobile: (0, app_1.detectBreakpoint)(app_1.Breakpoint.MD),
        });
    }
}
exports.TableCore = TableCore;
